import React from 'react';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

function Contact() {
  return (
    <div id="top">
      <div id="wrapper">
        <Header />
        <div id="navig_inside">
          <Navigation />
        </div>
        <div id="banner"></div>
        <div id="inside_page" className="bodyText">
          <div id="page1">
            <span className="bodyText">
              <p className="welcome_heading"><strong>Contact Us</strong></p>
              <div className="clear"></div>
            </span>
            <div id="facil">
              <table width="800" border="0" align="center" cellPadding="0" cellSpacing="0">
                <tbody>
                  <tr>
                    <td width="10">
                      <p><small><a href="/images/isrlargefe7b.jpg?f=q&amp;source=embed&amp;hl=en&amp;geocode=&amp;q=Indira+Shiva+Rao+Polytechnic,+Udupi,+Karnataka,+India&amp;aq=0&amp;oq=indira+s&amp;sll=12.922992,74.852064&amp;sspn=0.235242,0.363579&amp;t=m&amp;ie=UTF8&amp;hq=Indira+Shiva+Rao+Polytechnic,+Udupi,+Karnataka,+India&amp;ll=13.347842,74.754024&amp;spn=0.021713,0.032015" target="new" style={{ color: '#0000FF', textAlign: 'left' }}><br />
                      </a></small></p>
                      <p>&nbsp;</p>
                      <p>&nbsp;</p>
                    </td>
                    <td width="790">
                      <div style={{ textAlign: 'center' }}>
                        <p className="recognition"><strong>For more information and feedback, please contact:</strong></p>
                        <p><img src="/images/PRINCIPAL PHOTO-1(1).jpg" width="250" height="103" alt="Principal" /><br />
                          <br />
                          <strong className="sec_nav_text">Mr. Srinath Nayak</strong><br />
                          The Principal<br />
                          Indira Shiva Rao Polytechnic<br />
                          Moodu Perampalli, Udupi-576102<br />
                          Karnataka<br />
                          <strong>Phone No:</strong> 0820 - 2574049, 8762070232<br />
                          <strong>E-Mail: </strong>isrpsksp@yahoo.com<strong></strong><br />
                          <strong>Website:</strong> www.isrpolytechnic.com<strong> </strong></p>
                        <div id="social">
                          <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/channel/UCncyXiI7OuroF73zRF8MDPA">
                            <img src="/images/yt.png" style={{ paddingRight: '20px' }} alt="YouTube" />
                          </a>
                          <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/indira.shivarao/">
                            <img src="/images/fb.png" alt="Facebook" />
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p className="recognition">&nbsp;</p>
              <strong><br /></strong>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default Contact;
